import mail from '@/urls/mail'
import {
  sendGetRequest,
} from '@/helper/requests'

const state = {
  mail: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    // next: null,
    // prev: null,
    error: null
  }
}

const getters = {
  getMail: state => state.mail.items,
  getMailCount: state => state.mail.count,
  getCurrentUrl: state => state.mail.currentUrl,
  getMailDetail: state => state.mail.detail,
  // getNext: state => state.mail.next,
  // getPrev: state => state.mail.prev,
  isLoadingMail: state => state.mail.loading,
  saveMailError: state => state.mail.error
}

const actions = {
  loadMailList: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает список почтовых сообщений
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} params.urlAppend - функция для модификации URL (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    if (!url) {
      url = mail.MAIL.MAIL_LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingMail) {
      commit('SET_MAIL_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_MAIL', data.results)
          commit('SET_MAIL_COUNT', data.count)
          // commit('SET_MAIL_NEXT', data['next']);
          // commit('SET_MAIL_PREV', data['prev']);
          commit('SET_MAIL_CURRENT_URL', url)
          commit('SET_MAIL_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_MAIL_LOADING_END')
          commit('SAVE_MAIL_ERROR', data)
          catcher(data, url)
        }
      )
    }
  }
}

const mutations = {
  SET_MAIL: (state, items) => {
    /**
     * Устанавливает список почтовых сообщений
     * @param {Object} state - состояние хранилища
     * @param {Array} items - массив почтовых сообщений
     */
    state.mail.items = items
  },

  SET_MAIL_COUNT: (state, value) => {
    /**
     * Устанавливает общее количество почтовых сообщений
     * @param {Object} state - состояние хранилища
     * @param {number} value - количество сообщений
     */
    state.mail.count = value
  },
  // SET_NEXT: (state, value) => {
  //   state.mail.next = value
  // },
  // SET_PREV: (state, value) => {
  //   state.mail.prev = value
  // },
  SET_MAIL_CURRENT_URL: (state, value) => {
    /**
     * Устанавливает текущий URL для пагинации
     * @param {Object} state - состояние хранилища
     * @param {string} value - URL текущего запроса
     */
    state.mail.currentUrl = value
  },

  SET_MAIL_LOADING: (state) => {
    /**
     * Включает индикатор загрузки почтовых сообщений
     * @param {Object} state - состояние хранилища
     */
    state.mail.loading = true
  },

  SET_MAIL_LOADING_END: (state) => {
    /**
     * Выключает индикатор загрузки почтовых сообщений
     * @param {Object} state - состояние хранилища
     */
    state.mail.loading = false
  },

  SAVE_MAIL_ERROR: (state, error) => {
    /**
     * Сохраняет ошибку при работе с почтовыми сообщениями
     * @param {Object} state - состояние хранилища
     * @param {Object} error - объект ошибки
     */
    state.mail.error = error
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
